<template>
  <!-- <div v-html="content" class="goods-content" :class="{ 'text-format': isText ,'need-magin': needMagin}">
  </div> -->
  <div v-append="content" class="goods-content" :class="{ 'text-format': isText ,'need-magin': needMagin}"></div>
</template>

<script>
export default {
  name: 'goods-content',
  props: {
    content: { type: String, default: '' }
  },
  computed: {
    isText() {
      const content = this.content || ''
      return content.indexOf('<img') === -1 // 不包含图片
    },
    // 老版的富文本使用富文本编辑器生成  新版富文本使用模块化数据生成 最外层加个外边距
    needMagin() {
      const content = this.content || ''
      return content.indexOf('<div style="display: flex;flex-flow: column;padding-bottom: 10px;"') !== -1
    }
  }
}
</script>

<style lang="scss">
.goods-content {
  &.need-magin{
    margin: .45rem;
  }
  img{
    display: block;
    flex-shrink: 0;
  }
  // 文本内容时的格式
  &.text-format {
    font-size: 0.3rem;
    font-weight: 400;
    color: #333333;
    line-height: 0.55rem;
    padding: 0.45rem;
    p {
      padding-bottom: 0.3rem;
    }
    ul {
      padding-left: 0.45rem;
      li {
        list-style: disc !important;
      }
    }
    ol {
      padding-left: 0.45rem;
      li {
        list-style: decimal !important;
      }
    }
  }
}
</style>
